module.exports = __webpack_public_path__ + "img/07-bg.278e63dd.jpg";